import { createSlice } from '@reduxjs/toolkit'
import { localStorage } from 'lib/core/services/localStorage'
import { Slice } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false
}

const slice = createSlice({
  name: 'quote/cartId',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchCartId (getNewToken = false): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    if (getNewToken) {
      localStorage.remove('cartToken')
    }

    const cartId = localStorage.get('cartToken')
    dispatch(request())

    if (cartId) {
      dispatch(success())
    } else {
      try {
        const response = await magentoClient.getClient().quote.createEmptyCart()
        const { data } = response
        const cartId = data.createEmptyCart
        if (cartId) {
          localStorage.set('cartToken', cartId)
          dispatch(success())
          return cartId
        } else {
          dispatch(failure())
        }
        return response
      } catch (e) {
        dispatch(failure())
      }
    }
  }
}
